export default "__VITE_ASSET__d456051a__"